/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { PatientOperation } from '@/api/operations/models/patient-operation'

@Component
export class PatientOperationGuardMixin extends Vue {
    /// GUARD OPERATIONS ///

    $_canCreatePatient(): boolean {
        return this.$_hasOperationInAnyLaboratory(PatientOperation.CREATE)
    }
    $_canEditPatient(): boolean {
        return this.$_hasOperationInAnyLaboratory(PatientOperation.EDIT)
    }
    $_canDeletePatient(): boolean {
        return this.$_hasOperationInAnyLaboratory(PatientOperation.DELETE)
    }
    $_canMergePatient(): boolean {
        return this.$_hasOperationInAnyLaboratory(PatientOperation.MERGE)
    }
    $_canAttachDocumentToPatient(): boolean {
        return this.$_hasOperationInAnyLaboratory(PatientOperation.ATTACH)
    }

    /// CAN BE ///

    $_canBeDocumentAttachedToPatient(patient: any): boolean {
        return true // TODO: is left ready for a possible future canBe
    }
}
